
const Genders = [
  { id: 1, name: 'Male'},
  { id: 2, name: 'Female'},
  { id: 3, name: 'Brand'},
  { id: 4, name: 'Other'},
]

export {
  Genders
}